<template>
  <div>
    <SearchForm @change="fetchData" ref="search"></SearchForm>
    <el-table
      ref="multipleTable"
      :data="tableData"
      style="width: 100%"
      @sort-change="handleSort"
    >
      <el-table-column prop="id" label="内容">
        <template v-slot="column">
          <ExercisePreview :entity="column.row"></ExercisePreview>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="50">
        <template slot-scope="scope">
          <el-button @click="handleSelect(scope.row)" type="text" size="small">添加</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 50, 100, 200]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
  </div>
</template>

<script>
import ExercisePreview from './ExercisePreview'
import SearchForm from './SearchForm'

export default {
  name: 'ExerciseList',
  data () {
    return {
      types: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      tableData: [],
      selections: [],
      sort: '-id'
    }
  },
  components: { ExercisePreview, SearchForm },
  created () {
    this.fetchTypes()
    this.fetchData()
  },
  watch: {
    sort () {
      this.fetchData()
    }
  },
  methods: {
    toggleSelection (rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row)
        })
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    },
    handleSelect (val) {
      this.$emit('change', {
        type: 'exercise',
        entity: val
      })
      if (this.$refs.search.notAdd) {
        this.fetchData()
      }
    },
    handleSort ({column, prop, order}) {
      this.sort = order === 'ascending' ? prop : ('-' + prop)
    },
    fetchTypes () {
      return this.$http.get(this.$urls.exercise_type_list, {
        params: {
          page: 1,
          'per-page': 1000
        }
      }).then(res => {
        this.types = res.data
      })
    },
    tabactivated() {
      this.tabdeactive = false
      if (this.filterChanged) {
        this.fetchData()
      }
    },
    tabdeactivated() {
      this.tabdeactive = true
    },
    fetchData () {
      if (this.tabdeactive) {
        this.filterChanged = true
        return
      }
      this.filterChanged = false
      let params = {
        status: 1,
        page: this.currentPage,
        'per-page': this.pageSize,
        sort: this.sort
      }
      if (this.$refs.search) {
        Object.assign(params, {
          level: this.$refs.search.level,
          num: this.$refs.search.num,
          knowType: this.$refs.search.knows,
          data_json: this.$refs.search.search,
          notAdd: this.$refs.search.notAdd ? 1 : 0,
        })
      }
      return this.$http.get(this.$urls.exercise_list, { params }).then(res => {
        this.total = Number.parseInt(res.headers['x-pagination-total-count'])
        this.currentPage = Number.parseInt(res.headers['x-pagination-current-page'])
        this.tableData = res.data
      })
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      this.fetchData()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.fetchData()
    }
  }
}
</script>